export default __webpack_public_path__ + "static/media/avatar_6_1.5b5dcbcd.png";